<template>
  <!-- <div class="notification" :class="{'active' : isShowNotification}">
    <div class="notification__wrapper" v-bar>
      <div class="notification__list">
        <transition-group name="list">

          <div
            v-for="(notification, index) in notifications"
            :key="index"
            class="notification__item"
            :class="{
                            'notification__item--group' :notification.items.length > 1,
                            'notification__item--new' : notification.items[0].is_new
                        }"
            @click="readNotification(notification, index)"
          >
            <div class="notification__item-status"></div>
            <div
              v-if="notification.items.length == 1"
              class="notification__item-img"
              :style="{ backgroundImage: 'url(' + notification.items[0].image +')' }"
            >
              <span>{{ notification.items[0].image ? '' : notification.items.length}}</span>
            </div>
            <div v-else class="notification__item-img">
              <span
                v-if="notification.items[0].type == 'new_request' || notification.items[0].type == 'new_landing_request'"
              >1</span>
              <span v-else>{{notification.items.length}}</span>
            </div>

            <div class="notification__item-content">
              <div class="notification__item-type">
                <div v-if="notification.items[0].type == 'message'">
                  {{
                  $t('notifications.newMessage') }}
                </div>
                <div v-else-if="notification.items[0].type == 'new_request'">
                  {{
                  $t('notifications.newRequest') }}
                </div>
                <div v-else-if="notification.items[0].type == 'new_client'">
                  {{
                  $t('notifications.newClient') }}
                </div>
                <div
                  v-else-if="notification.items[0].type == 'master_not_shift'"
                >{{$t('notifications.masterWasLate') }}</div>
                <div
                  v-else-if="notification.items[0].type == 'call'"
                >{{$t('notifications.missedCall')}}</div>
                <div v-else-if="notification.items[0].type =='new_landing_request'">
                  <span>{{$t('notifications.newLandingRequest')}}</span>
                </div>
                <div v-else-if="notification.items[0].type =='cancel_request'">
                  <span>{{$t('notifications.cancelRequest')}}</span>
                </div>
                <div v-else-if="notification.items[0].type =='missed_call'">
                  <span>Missed call</span>
                </div>
              </div>

              <div class="notification__item-text">
                <div v-if="notification.items[0].type == 'message'">
                  <span>{{notification.items[0].name}}</span>
                  {{
                  $t('notifications.messageDescription') }}
                </div>

                <div v-else-if="notification.items[0].type == 'new_request'">
                  <span>{{ notification.items[0].name }}</span>
                  {{
                  $t('notifications.viewNewRequest') }}
                </div>

                <div v-else-if="notification.items[0].type == 'new_client'">
                  <span>{{notification.items[0].name}}</span>
                  {{ $t('notifications.clientDescription') }}
                </div>

                <div
                  v-else-if="notification.items[0].type == 'master_not_shift'"
                >{{$t('notifications.masterWasLateDescription') }}</div>

                <div v-else-if="notification.items[0].type == 'call'">
                  {{$t('notifications.missedCallText')}} {{notification.items[0].name}}
                  {{$t('notifications.callBack')}}
                </div>
                <div v-else-if="notification.items[0].type =='new_landing_request'">
                  <span>{{$t('notifications.newLandingRequestDesc')}}</span>
                </div>
                <div v-else-if="notification.items[0].type =='cancel_request'">
                  <span>{{notification.items[0].name}} {{$t('notifications.cancelRequestDescription')}}</span>
                </div>

                <div v-else-if="notification.items[0].type =='missed_call'">
                  <span>Missed call</span>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>-->
  <div
    class="notification-box"
    :class="{
      'notification-box_show': isShowNotification,
      'notification-box_hide': false,
    }"
  >
    <div class="notification-box__list">
      <div
        class="notification-item"
        v-for="(notification, index) in notifications"
        :key="index"
        @click="readNotification(notification, index)"
      >
        <div class="notification-item__box">
          <div class="notification-item__image">
            <template v-if="notification.items[0].type === 'new_request'">
              <image-source
                :source="notification.items[0].source || 'unknown'"
              />
            </template>

            <template v-else-if="notification.items[0].type === 'new_client'">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.3998 3C10.906 3 9.35754 5.08059 9.35754 8.12287C9.28152 8.44766 9.24121 8.78512 9.24121 9.13179C9.24121 10.473 9.84241 11.6846 10.8099 12.5507C11.2055 14.333 12.6728 15.6563 14.4234 15.6563C16.1734 15.6563 17.6407 14.333 18.0364 12.5507C19.0038 11.6846 19.6056 10.473 19.6056 9.13179C19.6056 8.78109 19.5636 8.43902 19.4858 8.11021C19.4858 4.4863 17.9402 3 14.3998 3Z"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.8692 19.0249C21.1353 18.0344 18.1633 16.8948 18.1633 16.8948C18.1633 16.8948 17.4699 22.3937 14.3989 25.3657C11.2282 22.3436 10.6339 16.8948 10.6339 16.8948C10.6339 16.8948 7.66183 18.0344 5.92791 19.0249C4.19399 20.0154 2.90578 23.2356 3.00541 25.0686C4.29304 26.901 14.3989 27 14.3989 27C14.3989 27 24.5041 26.901 25.7917 25.0686C25.8908 23.2356 24.6031 20.0154 22.8692 19.0249Z"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.2593 18.6782H15.4884L15.1418 20.3125H13.6059L13.2593 18.6782Z"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.4884 22.2941L14.4479 24.5728L13.2593 22.2941L13.6059 20.6599H15.1412L15.4884 22.2941Z"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.5005 3.66864C11.5005 3.66864 13.1849 8.37459 15.9093 8.32507C19.6322 8.25769 19.4739 7.5822 19.4739 7.5822"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.086 6.59131C13.086 6.59131 11.7488 9.01857 9.37109 8.12713"
                  stroke="var(--menu-text-color)"
                  stroke-linejoin="round"
                />
              </svg>
            </template>

            <template v-else-if="notification.items[0].type === 'message'">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.35597 3C5.33579 3 4.5 3.8313 4.5 4.84589V10.3836C4.5 11.3982 5.33579 12.2294 6.35597 12.2294H7.28395V14.5368C7.28328 14.7228 7.39495 14.8911 7.5672 14.9635C7.73947 15.036 7.93862 14.9985 8.07236 14.8685L10.7911 12.2294H15.6358C16.656 12.2294 17.4917 11.3982 17.4917 10.3836V4.84589C17.4917 3.8313 16.656 3 15.6358 3H6.35597Z"
                  stroke="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.1811 15C23.2013 15 24.0371 15.8313 24.0371 16.8459V22.3836C24.0371 23.3982 23.2013 24.2294 22.1811 24.2294H21.2532V26.5368C21.2538 26.7228 21.1422 26.8911 20.9699 26.9635C20.7976 27.036 20.5985 26.9985 20.4647 26.8685L17.746 24.2294H12.9013C11.8811 24.2294 11.0454 23.3982 11.0454 22.3836V16.8459C11.0454 15.8313 11.8811 15 12.9013 15H22.1811Z"
                  stroke="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.1367 5.7769C21.9458 5.77835 21.7748 5.89247 21.7044 6.06542C21.634 6.23838 21.6782 6.43568 21.8161 6.56432L22.4224 7.14818H19.8695C19.8537 7.14741 19.8378 7.14741 19.8219 7.14818C19.6543 7.15642 19.504 7.25118 19.4275 7.39679C19.3511 7.54239 19.3602 7.7167 19.4513 7.854C19.5425 7.9913 19.702 8.07074 19.8695 8.06238H22.4224L21.8161 8.64624C21.6857 8.75828 21.6296 8.93142 21.6703 9.09614C21.711 9.26087 21.8418 9.39015 22.0102 9.43208C22.1786 9.474 22.357 9.4217 22.4737 9.29618L23.8971 7.93026C23.9867 7.84431 24.0371 7.72691 24.0371 7.60439C24.0371 7.48187 23.9867 7.36447 23.8971 7.27854L22.4737 5.9126C22.3848 5.8249 22.2632 5.77598 22.1367 5.7769Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.9463 6.57022C10.3986 6.57022 9.95459 7.01422 9.95459 7.56196C9.95459 8.1097 10.3986 8.55369 10.9463 8.55369C11.4941 8.55369 11.9381 8.1097 11.9381 7.56196C11.9381 7.01422 11.4941 6.57022 10.9463 6.57022Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.4175 6.57022C13.8698 6.57022 13.4258 7.01422 13.4258 7.56196C13.4258 8.1097 13.8698 8.55369 14.4175 8.55369C14.9652 8.55369 15.4093 8.1097 15.4093 7.56196C15.4093 7.01422 14.9652 6.57022 14.4175 6.57022Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.47515 6.57022C6.9274 6.57022 6.4834 7.01422 6.4834 7.56196C6.4834 8.1097 6.9274 8.55369 7.47515 8.55369C8.02287 8.55369 8.46687 8.1097 8.46687 7.56196C8.46687 7.01422 8.02287 6.57022 7.47515 6.57022Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.9628 18.5703C21.5106 18.5703 21.9546 19.0142 21.9546 19.562C21.9546 20.1097 21.5106 20.5537 20.9628 20.5537C20.4151 20.5537 19.9711 20.1097 19.9711 19.562C19.9711 19.0142 20.4151 18.5703 20.9628 18.5703Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.4916 18.5703C18.0394 18.5703 18.4834 19.0142 18.4834 19.562C18.4834 20.1097 18.0394 20.5537 17.4916 20.5537C16.9439 20.5537 16.4999 20.1097 16.4999 19.562C16.4999 19.0142 16.9439 18.5703 17.4916 18.5703Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.0205 18.5703C14.5682 18.5703 15.0122 19.0142 15.0122 19.562C15.0122 20.1097 14.5682 20.5537 14.0205 20.5537C13.4728 20.5537 13.0287 20.1097 13.0287 19.562C13.0287 19.0142 13.4728 18.5703 14.0205 18.5703Z"
                  fill="var(--menu-text-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.40043 17.7769C6.59135 17.7784 6.76229 17.8925 6.8327 18.0654C6.90311 18.2384 6.85895 18.4357 6.72101 18.5643L6.11468 19.1482H8.66756C8.68343 19.1474 8.69932 19.1474 8.71519 19.1482C8.88278 19.1564 9.03313 19.2512 9.10958 19.3968C9.18602 19.5424 9.17693 19.7167 9.08577 19.854C8.99458 19.9913 8.83515 20.0707 8.66756 20.0624H6.11468L6.72101 20.6462C6.85141 20.7583 6.90752 20.9314 6.86685 21.0961C6.82615 21.2609 6.69536 21.3902 6.52693 21.4321C6.35852 21.474 6.18014 21.4217 6.06339 21.2962L4.64005 19.9303C4.55043 19.8443 4.49998 19.7269 4.49998 19.6044C4.49998 19.4819 4.55043 19.3645 4.64005 19.2785L6.06339 17.9126C6.15235 17.8249 6.2739 17.776 6.40043 17.7769Z"
                  fill="var(--menu-text-color)"
                /></svg
            ></template>

            <template
              v-else-if="notification.items[0].type === 'cancel_request'"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
                  fill="var(--menu-text-color)"
                ></path>
              </svg>
            </template>

            <template v-else>
              <svg
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 330 330"
                xml:space="preserve"
                fill="var(--menu-text-color)"
                stroke="none"
              >
                <g>
                  <path
                    d="M164.998,70c-11.026,0-19.996,8.976-19.996,20.009c0,11.023,8.97,19.991,19.996,19.991
		c11.026,0,19.996-8.968,19.996-19.991C184.994,78.976,176.024,70,164.998,70z"
                  />
                  <path
                    d="M165,140c-8.284,0-15,6.716-15,15v90c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-90C180,146.716,173.284,140,165,140z
		"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </template>
          </div>
          <div class="notification-item__content">
            <div class="notification-item__title">
              <span v-if="notification.items[0].type === 'message'">
                {{ $t("notifications.newMessage") }}
              </span>
              <span v-else-if="notification.items[0].type === 'new_request'">
                {{ $t("notifications.newRequest") }}
              </span>
              <span v-else-if="notification.items[0].type === 'new_client'">
                {{ $t("notifications.newClient") }}
              </span>
              <span
                v-else-if="notification.items[0].type === 'master_not_shift'"
                >{{ $t("notifications.masterWasLate") }}</span
              >
              <span v-else-if="notification.items[0].type === 'call'">{{
                $t("notifications.missedCall")
              }}</span>
              <!-- <span
                v-else-if="notification.items[0].type == 'new_landing_request'"
              >
                <span>{{ $t("notifications.newLandingRequest") }}</span>
              </span> -->
              <span v-else-if="notification.items[0].type === 'cancel_request'">
                <span>{{ $t("notifications.cancelRequest") }}</span>
              </span>
              <span v-else-if="notification.items[0].type === 'missed_call'">
                <span>Missed call</span>
              </span>
            </div>

            <div class="notification-item__text">
              <span class="notification-item__text-name">{{
                notification.items[0].name
              }}</span>
              <span v-if="notification.items[0].type === 'message'"
                >{{ $t("notifications.messageDescription") }}}}</span
              >
              <span v-else-if="notification.items[0].type === 'new_request'">{{
                $t("notifications.viewNewRequest")
              }}</span>
              <span v-else-if="notification.items[0].type === 'new_client'">{{
                $t("notifications.clientDescription")
              }}</span>
              <span
                v-else-if="notification.items[0].type === 'master_not_shift'"
                >{{ $t("notifications.masterWasLateDescription") }}</span
              >
              <span v-else-if="notification.items[0].type === 'call'"></span>
              <!-- <span
                v-else-if="notification.items[0].type == 'new_landing_request'"
                >{{ $t("notifications.newLandingRequestDesc") }}</span
              > -->
              <span
                v-else-if="notification.items[0].type === 'cancel_request'"
                >{{ $t("notifications.cancelRequestDescription") }}</span
              >
              <span v-else-if="notification.items[0].type === 'missed_call'"
                >Missed call</span
              >
              <!-- new_landing_request -->
            </div>
          </div>
          <!-- <div class="notification-item__time">
          <span>5 min ago</span>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import imageSource from '@/components/controls/imageSource'

export default {
    components: {
        imageSource,
    },
    props: {
        notifications: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            isShowNotification: 'isShowNotification',
        }),
    },
    methods: {
        ...mapMutations({
            hideNotification: 'hideNotification',
        }),
        inNotificationTypes(type) {
            const types = ['message']

            if (types.includes(type)) {
                return true
            }

            return false
        },
        async readNotification(res) {
            const data = res.items
            const item = data[0]
            // const itemByIndex = data[index];

            const { type } = item
            const isNew = item.is_new
            const clientId = item.client_id
            const masterId = item.master_id
            const notification_id = item.id
            // const requestId = item.request_id
            // const landing_request_id = item.landing_request_id;

            let read = true

            switch (type) {
            // case "new_landing_request":
            //   read = false;
            //   this.onNewLandingRequest({
            //     notification_id,
            //     data: [item],
            //     landing_request_id,
            //   });
            //   break;

            case 'message':
                read = false
                await this.onMessage({
                    masterId,
                    clientId,
                    item,
                    notification_id,
                    data,
                })
                break

            case 'new_request':
                read = false
                await this.onNewRequest({
                    notification_id: item.id,
                    requestId: item.request_id,
                    item,
                    data: [item],
                })
                break

            case 'call':
                this.onCall(item)
                break

            case 'new_client':
                read = false
                await this.onRegistration({ notification_id, data })
                break

            case 'master_not_shift':
                this.onMasterNotShift()
                break

            case 'missed_call':
                this.onMissedCall(item)
                break

            case 'cancel_request':
                break
            default:
                break
            }

            if (isNew && read) {
                this.markNewNotification(data)
            }

            this.hideNotification()
        },
        checkPage(page) {
            return this.$route.path === page
        },
        onCall(item) {
            const user = {
                fullName: item.name,
                photo: item.image,
                id: item.client_id || item.master_id || item.engineer_id,
                type: item.call_type,
                isAnswer: false,
                isAudioCall: false,
            }
            const isClosedCallModal = this.$store.state.calls.show === false

            if (isClosedCallModal) {
                this.$store.dispatch('showCallModal', user)
            }
        },
        onMasterNotShift() {
            this.$router.push({ name: 'masters' })
        },
        onMissedCall(item) {
            const userCb = {
                fullName: item.full_name,
                photo: null,
                id: item.client_id,
                type: 'clients',
                isAnswer: false,
                isAudioCall: false,
            }
            const isClosedCallModal = this.$store.state.calls.show === false

            if (isClosedCallModal) {
                this.$store.dispatch('showCallModal', userCb)
            }
        },
        // actions end
        markNewNotification(data) {
            const notifications = data.reduce((accum, item) => {
                accum.push(item.id)
                return accum
            }, [])

            this.$store.dispatch('readNotification', notifications)
        },
        // onNewLandingRequest({ notification_id, data, landing_request_id }) {
        //   notificationMananger
        //     .addToPull({
        //       route: {
        //         name: "Requests",
        //         notification_id,
        //         landing_request_id,
        //       },
        //       data,
        //       id: landing_request_id,
        //     })
        //     .onNewLandingRequest(landing_request_id);
        // },
        async onMessage({
            masterId, clientId, item, notification_id,
        }) {
            const messages = []
            this.$store.state.notifications.notifications.forEach((element) => {
                if (
                    element.type === 'message'
          && element.items[0].client_id === clientId
                ) {
                    messages.push(element.items[0])
                }
            })

            window.notificationMananger.addToPull({
                route: {
                    name: 'chat',
                    id: masterId === null ? clientId : masterId,
                    type: item.dialog_type,
                    notification_id,
                },
                item,
                data: messages,
                id: item.id,
            })

            await window.notificationMananger.onMessage(item.id)
        },
        async onNewRequest({
            notification_id, requestId, item, data,
        }) {
            window.notificationMananger.addToPull({
                route: {
                    name: 'orders',
                    notification_id,
                    requestId,
                },
                item,
                data,
                id: item.id,
            })

            await window.notificationMananger.onNewRequest(item.id)
        },
        async onRegistration({ notification_id, data }) {
            window.notificationMananger.addToPull({
                route: {
                    name: 'clients',
                    notification_id,
                },
                data,
                id: notification_id,
            })

            await window.notificationMananger.onRegistration(notification_id)
        },
    },
    beforeMount() {
        window.notificationMananger.setContext(this)
    },
}
</script>
